import React from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ContextProviders from "./contexts/ContextProviders";
import { ToastProvider } from "contexts/ToastContext";
import { TranslationProvider } from "contexts/i18nContext";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <TranslationProvider>
      <ContextProviders>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </ContextProviders>
    </TranslationProvider>
  </React.StrictMode>
);

reportWebVitals();
